import { faTrashAlt } from '@fortawesome/pro-light-svg-icons'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { digObject, formatDate } from '@domain-group/javascript-utils'

import { confirmDelete } from '@functions/entity'

import useIntegration from '@hooks/useIntegration'

import { IntegrationModel } from '@domain-group/realhub-backend-api-types'

type IntegrationsProps = {
  integration: IntegrationModel,
}

const Integration = (props: IntegrationsProps) => {
  const { integration } = props

  const integrationPayload = useIntegration(integration)
  const {
    callbacks: { manageUserIntegration, deleteIntegration: deleteFn },
    integration: { access_token, dates },
    title,
  } = integrationPayload

  const expiresDate = digObject(dates, 'expires.date_time')
  const expiresAt = formatDate(expiresDate, 'dd/MM/yyyy HH:mm', 'dd/MM/yyyy \'at\' HH:mm')

  const confirmDeleteParams = {
    callbacks: {
      deleteFn,
    },
    strings: {
      confirmString: 'Are you sure? This may affect data sync between systems.',
      entityName: 'Integration',
    },
  }

  return (
    <DashboardModuleListItem
      key={integration?.id}
      title={title}
      secondaryText={expiresAt || 'No Expiry'}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {!!access_token && (
          // @ts-expect-error TS2339
          <DashboardModuleListItem.Icon
            marginRight="medium"
            onClick={() => manageUserIntegration()}
            type="edit"
          />
        )}

        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          marginRight="medium"
          icon={faTrashAlt}
          onClick={() => confirmDelete(confirmDeleteParams)}
        />
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default Integration
